import React, {useEffect, useState} from "react";
import {Checkbox, Grid, IconButton, Box, Typography} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import {getAmountWithSign} from "../../../helper-functions/CardHelpers";
import { styled } from "@mui/material/styles";

// Styled components for enhanced design
const StyledAddonContainer = styled(Box)(({ theme, isSelected }) => ({
    padding: '12px 16px',
    borderRadius: '12px',
    border: `2px solid ${isSelected ? theme.palette.primary.main : theme.palette.divider}`,
    backgroundColor: isSelected ? theme.palette.primary.light + '08' : theme.palette.background.paper,
    transition: 'all 0.3s ease',
    marginBottom: '8px',
    '&:hover': {
        borderColor: theme.palette.primary.main,
        backgroundColor: theme.palette.primary.light + '12',
        transform: 'translateY(-1px)',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
    }
}));

const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
    padding: '4px',
    '& .MuiSvgIcon-root': {
        fontSize: '1.5rem',
        borderRadius: '4px'
    },
    '&.Mui-checked': {
        color: theme.palette.primary.main
    }
}));

const AddonName = styled(Typography)(({ theme }) => ({
    fontWeight: 500,
    fontSize: '14px',
    color: theme.palette.text.primary,
    lineHeight: 1.4
}));

const AddonPrice = styled(Typography)(({ theme }) => ({
    fontWeight: 600,
    fontSize: '14px',
    color: theme.palette.primary.main
}));

const QuantityButton = styled(IconButton)(({ theme, disabled }) => ({
    width: '32px',
    height: '32px',
    borderRadius: '8px',
    border: `1px solid ${disabled ? theme.palette.divider : theme.palette.primary.main}`,
    backgroundColor: disabled ? theme.palette.action.disabledBackground : 'transparent',
    color: disabled ? theme.palette.action.disabled : theme.palette.primary.main,
    '&:hover': {
        backgroundColor: disabled ? theme.palette.action.disabledBackground : theme.palette.primary.light + '20'
    },
    '& .MuiSvgIcon-root': {
        fontSize: '1rem'
    }
}));

const QuantityDisplay = styled(Box)(({ theme }) => ({
    minWidth: '40px',
    height: '32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.background.default,
    borderRadius: '6px',
    fontWeight: 600,
    fontSize: '14px',
    color: theme.palette.text.primary
}));

const IncDecAddOn = ({
                         changeAddOns,
                         add_on,
                         selectedAddons,
                     }) => {

    const [addOn, setAddOn] = useState(
        {
            name: '',
            isChecked: false,
            quantity: 0
        }
    );

    useEffect(() => {
        if (selectedAddons?.length > 0) {
            const existedAddOn = selectedAddons?.find((item) => item?.id === add_on?.id && item?.store_id === add_on?.store_id)
            if (existedAddOn) {
                setAddOn({...existedAddOn, isChecked: Boolean(existedAddOn.isChecked)})
            } else {
                setAddOn({...add_on, quantity: 0, isChecked: false, name: add_on?.name})
            }
        } else {
            setAddOn({...add_on, quantity: 0, isChecked: false, name: add_on?.name})
        }
    }, [add_on, selectedAddons]);
    const changeCheckedAddOn = (e) => {
        if (e.target.checked) {
            const changedObj = {...addOn, quantity: addOn?.quantity + 1, isChecked: true, name: addOn.name}
            setAddOn(changedObj)
            changeAddOns(changedObj)
        } else {
            const changedObj = {...addOn, quantity: addOn?.quantity - 1, isChecked: false, name: addOn.name}
            setAddOn(changedObj)
            changeAddOns(changedObj)
        }
    };

    const incrementAddOnQty = () => {
        const changedObj = {...addOn, quantity: addOn?.quantity + 1}
        setAddOn(changedObj)
        changeAddOns(changedObj)
    };
    const decrementAddOnQty = () => {
        const changedObj = {...addOn, quantity: addOn?.quantity - 1}
        setAddOn(changedObj)
        changeAddOns(changedObj)
    };

    return (
        <>
            {addOn && (
                <StyledAddonContainer isSelected={addOn?.isChecked}>
                    <Grid container alignItems="center" spacing={2}>
                        <Grid item xs={1}>
                            <StyledCheckbox 
                                onChange={changeCheckedAddOn} 
                                checked={addOn?.isChecked}
                                size="medium"
                            />
                        </Grid>
                        <Grid item xs={5}>
                            <AddonName>
                                {addOn?.name}
                            </AddonName>
                        </Grid>
                        <Grid item xs={3}>
                            <AddonPrice>
                                {getAmountWithSign(addOn?.price)}
                            </AddonPrice>
                        </Grid>
                        <Grid item xs={3}>
                            <Box display="flex" alignItems="center" justifyContent="flex-end" gap={1}>
                                <QuantityButton
                                    disabled={!addOn?.isChecked || addOn?.quantity === 0}
                                    onClick={decrementAddOnQty}
                                    size="small"
                                >
                                    <RemoveIcon />
                                </QuantityButton>
                                <QuantityDisplay>
                                    {addOn?.quantity}
                                </QuantityDisplay>
                                <QuantityButton
                                    disabled={!addOn?.isChecked}
                                    onClick={incrementAddOnQty}
                                    size="small"
                                >
                                    <AddIcon />
                                </QuantityButton>
                            </Box>
                        </Grid>
                    </Grid>
                </StyledAddonContainer>
            )}
        </>
    );
};

export default IncDecAddOn;
